export default __webpack_public_path__ + "static/media/animoca-light.3f992aec.svg";